import { cn } from '@natu/utils/cn';
import { isArrayWithLength } from '@natu/utils/isArrayWithLength';

import {
  type BlokItem,
  DynamicRender,
  resolveStoryblokStyles,
  sbEditable,
  type SBProps,
  type Spacing,
} from '../../../../utils';

interface SBOurServicesSectionProps {
  services: BlokItem[];
  mtMobile?: Spacing;
  mtTablet?: Spacing;
  mtDesktop?: Spacing;
  mbMobile?: Spacing;
  mbTablet?: Spacing;
  mbDesktop?: Spacing;
}
export const SBOurServicesSection = ({ blok }: SBProps<SBOurServicesSectionProps>) => {
  const { services, mbMobile, mbTablet, mbDesktop, mtMobile, mtTablet, mtDesktop } = blok;

  const className = resolveStoryblokStyles({
    mt: mtMobile,
    mtTablet,
    mtDesktop,
    mb: mbMobile,
    mbTablet,
    mbDesktop,
  });

  if (!isArrayWithLength(services)) return null;

  return (
    <ul className={cn(className, 'flex flex-col gap-y-8 lg:gap-y-16')} {...sbEditable(blok)}>
      <DynamicRender data={services} />
    </ul>
  );
};
